import React, {useState, useRef, useEffect, Fragment} from 'react';
import VisDiv from './frontend_components/VisDiv';
import { referenceDoc, richEditorDoc } from './gestioneDatabase/Docs';
import { useStateContext } from '../context/StateContext';
import { v4 as uuidv4 } from 'uuid';
import { addValueForDropdown, errorAlert, keyId, sortByLabel, objectIsObject, unique, successAlert, addNameSwal } from '../lib/utils';
import Divider from './frontend_components/Divider';
import TextField from './TextField';
import TrueFalseToggle from './TrueFalseToggle';
import Swal from 'sweetalert2';
import FieldDropdown from './FieldDropdown';
import { ArrayReference } from './management/ManageSchema';
import { TiDelete } from 'react-icons/ti';
import RichTextEditor from './RichTextEditor';
import { useQueryClient } from '@tanstack/react-query';
import SchemaImport from '../sanity_ecommerce/schemas/rich-module/richTextLabelValue'
import { useCreateReplace } from '../hooks/mutations';
import ManageSchema from './management/ManageSchema';
import { AddSupplierProduct } from './offerComponents/ProdottiFornitori';
import { IoIosAddCircleOutline } from 'react-icons/io';
import PriceLists from './offerComponents/PriceLists';
import ViewLabelValueField from './frontend_components/ViewLabelValueField';
import { StepByStepProgress } from './management/StepByStepProgress';
import { ReferenceCheckList, DecimalHours, decimalToHoursConverter } from './management/ManagementModules';
import TestButton from './frontend_components/TestButton';
import { useManagementContext } from '../context/ManagementContext';
import { IoIosArrowDropdownCircle, IoIosArrowDropupCircle } from "react-icons/io";
import SliderRegistriTemplates from './SliderRegistriTemplates';


const InsertNewSupplyCustomerProduct = ({data}) => {

    const {customerProducts, nonConformities, templateRegisters, presidioModules, deviceProperties, lists, dataModules, laws, products, suppliers, priceLists, hideCloseButton} = data 

    const {customer} = useStateContext()
    const {newSupplyCustomerProduct, setNewSupplyCustomerProduct, setNewSupplyCustomerProductEdited, newSupplyCustomerProductEdited} = useManagementContext()

    const queryClient = useQueryClient()

    const {mutate: updateDocument} = useCreateReplace({
        onMutate: async (newDoc) => {

            await queryClient.cancelQueries({ queryKey: ['customerProductsReport'] })
            const previousData = queryClient.getQueryData(['customerProductsReport'])
       
            //const doc = newDoc?.doc
            
            queryClient.setQueryData(['customerProductsReport'], (old) =>{ 
                const doc = newDoc?.doc
                const oldData = old?.length > 0 ? old : []
                const newData = [...oldData?.filter?.(x=>x?._id!== doc._id), doc]          
                return newData
            })
            return {previousData}
        },

        onError: (err, newDoc, context) => {
            console.error('Oh no, the update failed: ', err?.message)
            errorAlert("ERRORE; Il documento non è stato modificato Ricarica la pagina")
            
            //queryClient.setQueryData(['customerProductsReport'], context?.previousData)

        },
        onSuccess: (data, variables) => {
            successAlert("PRODOTTO FORNITURA AGGIORNATO CON SUCCESSO")
            setNewSupplyCustomerProductEdited(false)
        }
        })

        const save = (data, bypassEdit) => {
          setNewSupplyCustomerProduct(data)
           if(!bypassEdit){setNewSupplyCustomerProductEdited(true)}
          //updateDocument({doc: data})
          console.log("SAVE PRESIDIO DOC:", data)
      }
          const updateDatabase = async(doc) => {
                 await updateDocument({doc: doc})
      
          }
            const checkDuplicateText = (customerProduct, customerProducts) => {
                const customerProductsWithTextDescription = !Array.isArray(customerProducts) ? [] : customerProducts?.map?.((item)=>({...item, descriptionText: item?.details?.blocks?.map?.((x)=>x?.text)?.toString()}))
                const text = customerProduct?.details?.blocks?.map?.((x)=>x?.text)?.toString()
                const findDuplicates = customerProductsWithTextDescription?.filter?.((x)=>x?.descriptionText == text && !x?.descriptionNotUnique)
                if(customerProduct?.descriptionNotUnique) return false
                if (findDuplicates?.length > 1) { return true}
                return false
            }
            const findInDescription = (text="", customerProducts) => {
                const customerProductsWithTextDescription = !Array.isArray(customerProducts) ? [] : customerProducts?.map?.((item)=>({...item, descriptionText: item?.details?.blocks?.map?.((x)=>x?.text)?.toString()}))
                //const text = customerProduct?.details?.blocks?.map?.((x)=>x?.text)?.toString()
                const findInText = customerProductsWithTextDescription?.filter?.((x)=>x?.descriptionText?.includes(text))
                return findInText
            }
      
              const resetDoc = async() => {

                    const isDescirptionNotUnique = checkDuplicateText(newSupplyCustomerProduct, customerProducts)
                    if(isDescirptionNotUnique) return Swal.fire({
                        position: 'top',
                        icon: 'warning',
                        title: 'La descrizione non è univoca. Cambiare la descrizione o selezionare "descrizione non univoca" nelle impostazioni',
                        showConfirmButton: true,
                        confirmButtonText: 'OK'
                    });
                  if(newSupplyCustomerProductEdited){
                      const result = await Swal.fire({
            
                          title: 'Documento Non Salvato',
                          text: 'Vuoi uscire ugualmente? i dati andranno persi.',
                          icon: 'error',
                          showCancelButton: true,
                          confirmButtonText: 'Chiudi Documento',
                          cancelButtonText: 'Annulla'
                      });
                  
                      if (result.isConfirmed) {
                          // Fall back to mailto
                          setNewSupplyCustomerProduct(undefined)
                          setNewSupplyCustomerProductEdited(false)
                      }
                  } else {
                      setNewSupplyCustomerProduct(undefined)
                      setNewSupplyCustomerProductEdited(false)
                  }
                        
                }
                const archive = async () => {
                  const archivedDoc = {...newSupplyCustomerProduct, status:"ARCHIVIATO"}
                  console.log("ARCHIVIA", archivedDoc)
                  // Update cache first
                  await updateDocument({doc: archivedDoc});
                  // Then update local state
                  setNewSupplyCustomerProduct(archivedDoc);
                  setNewSupplyCustomerProductEdited(false)
              }
              const restore = async () => {
                  const restoredDoc = {...newSupplyCustomerProduct, status:"ATTIVO"}
                  console.log("ATTIVA", restoredDoc)
                  // Update cache first
                  await updateDocument({doc: restoredDoc});
                  // Then update local state
                  setNewSupplyCustomerProduct(restoredDoc);
                  setNewSupplyCustomerProductEdited(false)
              }
    const customerTemplates = !Array.isArray(templateRegisters) ? [] : templateRegisters?.filter?.((x)=>x?.customer?._ref == customer?._id)
    
    const assignedNonConformities = !Array.isArray(newSupplyCustomerProduct?.nonConformities) ? [] : newSupplyCustomerProduct?.nonConformities?.map?.((item)=>{
        const nonConformity = !Array.isArray(nonConformities) ? undefined : nonConformities?.find?.((x)=>x?._id == item?._ref)
        return nonConformity
    })
    const registerTemplateIdsInAssignedNonConformities = assignedNonConformities?.map?.((item)=>{
        return item?.registers?.map?.((x)=>({id:x?._ref}))
    })?.flat()
    const uniqueRegisterTemplateIdsInAssignedNonConformities = unique("id", registerTemplateIdsInAssignedNonConformities)?.map?.((x)=>{
        const isRegisterInNewCustomerProduct = !Array.isArray(newSupplyCustomerProduct?.registers) ? [] : newSupplyCustomerProduct?.registers?.some?.((y)=>y?._ref == x?.id)
        if(isRegisterInNewCustomerProduct) return x?.id
    })?.filter?.((x)=>x)

    // REFERENCE DATA FOR REFERENCE ARRAYS
    // if templates is in reference data it filters all the data by the present registers
    const templateRegistersReferenceData = {type: "referenceArray", hideFilter:true, data: customerTemplates, propertyName: "registers", } // disabledIds: uniqueRegisterTemplateIdsInAssignedNonConformities
    const nonConformitiesReferenceData = {type: "referenceArray", hideFilter:true, data: nonConformities, propertyName: "nonConformities", templates: customerTemplates}
    const assetsReferenceData = {type: "referenceArray", hideFilter:true, data: presidioModules, propertyName: "devices", templates: customerTemplates}
    const propertiesReferenceData = {type: "referenceArray", hideFilter:true, data: deviceProperties, propertyName: "deviceProperties", templates: customerTemplates, lists, dataModules}
    const supplierProductsReferenceData = {type: "referenceArray", hideFilter:true, data: products, propertyName: "supplierProducts", suppliers}
    const supplyCustomerProductsReferenceData = {type: "referenceArray", hideFilter:true, data: customerProducts?.filter?.((x)=>x?._id !== newSupplyCustomerProduct?._id), propertyName: "supplyCustomerProducts"}
    const substitutionCustomerProductsReferenceData = {type: "referenceArray", hideFilter:true, data: customerProducts?.filter?.((x)=>x?._id !== newSupplyCustomerProduct?._id), propertyName: "substitutionCustomerProducts"}
    const progressList = [
        {description: "NOME PRODOTTO INTERNO", component: <CustomerProductName doc={newSupplyCustomerProduct} setDoc={save} data={{}}/>},
        {description: "ASSEGNA TIPOLOGIE REGISTRO", component: <AssignRegisterTemplates doc={newSupplyCustomerProduct} setDoc={save} data={{referenceData:templateRegistersReferenceData}}/>},
        {description: "ASSEGNA NON CONFORMITA'", component: <AssignNonConformities doc={newSupplyCustomerProduct} setDoc={save} data={{referenceData:nonConformitiesReferenceData}}/>},
        {description: "ASSEGNA PRESIDI", component: <AssignAssets doc={newSupplyCustomerProduct} setDoc={save} data={{referenceData:assetsReferenceData}}/>},
        {description: "ASSEGNA PROPRIETA'", component: <AssignProperties doc={newSupplyCustomerProduct} setDoc={save} data={{referenceData:propertiesReferenceData}}/>},
        {description: "ASSEGNA PRODOTTI FORNITURA", component: <AssignSupplyCustomerProducts doc={newSupplyCustomerProduct} setDoc={save} data={{referenceData:supplyCustomerProductsReferenceData}}/>},
        {description: "ASSEGNA PRODOTTI SOSTITUZIONE", component: <AssignSubstitutionProduct doc={newSupplyCustomerProduct} setDoc={save} data={{referenceData:substitutionCustomerProductsReferenceData}}/>},
        {description: "IMPOSTAZIONI", component: <CustomerProductSettings doc={newSupplyCustomerProduct} setDoc={save} />},
        {description: "DESCRIZIONE E NORMA", component: <LawAndDescription doc={newSupplyCustomerProduct} setDoc={save} data={{laws, nonConformities}}/> },
        {description: "ASSEGNA PRODOTTO FORNITORE", component: <AssignSupplierProduct doc={newSupplyCustomerProduct} setDoc={save} data={{referenceData:supplierProductsReferenceData}}/> },
        {description: "ASSEGNA A LISTINO", component: <AssignPriceList doc={newSupplyCustomerProduct} setDoc={save} data={{priceLists, customer, hideSearch: true }}/> },

       //AssignSupplyCustomerProducts
        
      ]
 
    const consoleData = {
        assignedNonConformities,
        newSupplyCustomerProduct,
        registerTemplateIdsInAssignedNonConformities,
    }

  return (
    <div style={{overflow:"auto", height:"88vh", paddingBottom:"100px"}}>   

        <TestButton consoleData={consoleData} buttonId='kjdqildjuwwe' message={"NEW_SUPPLY_CUSTOMER_PRODUCT"}/>
            <div style={{display: "flex", alignItems:"center"}}>
                <VisDiv style={{marginBottom:"10px", marginRight:"10px"}} rules={[newSupplyCustomerProduct]}>
                    <button onClick={resetDoc} className={"pdf-button"}>CHIUDI DOCUMENTO</button>
                </VisDiv>
                <VisDiv style={{marginRight:"10px", marginBottom:"10px",}}  rules={[newSupplyCustomerProduct]}>
                    <button type="button" disabled={!newSupplyCustomerProductEdited} style={{backgroundColor: newSupplyCustomerProductEdited ? "green" : "grey"}} className="pdf-button" onClick={()=>updateDatabase(newSupplyCustomerProduct)} >
                        {"SALVA DOCUMENTO"}
                    </button>
                </VisDiv>
                <VisDiv style={{marginBottom:"10px", marginRight:"10px"}}  rules={[newSupplyCustomerProduct && newSupplyCustomerProduct?.status !== "ARCHIVIATO"]}>
                    <button type="button" style={{backgroundColor: "red"}} className="pdf-button" onClick={()=>archive()} >
                        {"ARCHIVIA"}
                    </button>
                </VisDiv>
                <VisDiv style={{marginBottom:"10px", marginRight:"10px"}}  rules={[newSupplyCustomerProduct?.status == "ARCHIVIATO"]}>
                    <button type="button" style={{backgroundColor: "green"}} className="pdf-button" onClick={()=>restore()} >
                        {"RIPRISTINA"}
                    </button>
                </VisDiv>
            </div>
            <VisDiv rules={[newSupplyCustomerProduct?.label]} style={{textAlign:"center"}}>
                <h2>PRODOTTO FORNITURA: {newSupplyCustomerProduct?.label}</h2>
            </VisDiv>
        <VisDiv rules={[!newSupplyCustomerProduct]}>
            <AddOrEditCustomerProduct updateDatabase={updateDatabase} doc={newSupplyCustomerProduct} setDoc={save} data={data}/>
        </VisDiv>
        <VisDiv rules={[newSupplyCustomerProduct]}>
            <StepByStepProgress progressList={progressList}/>
        </VisDiv>
    </div>
  )
}

export default InsertNewSupplyCustomerProduct

//=======================================================================================

/* export const ProgressHeader = ({progressTab, setProgressTab, progressList}) => {
  
  return (
    
    <div style={{display:"flex", cursor:"pointer", minHeight:"60px", backgroundColor:"white", justifyContent:"center", alignItems:"center", marginTop:"15px", marginBottom:"15px"}}>
        {progressList?.map?.((item, index)=>{
             const activeBackground = progressTab?.description == item?.description ? {backgroundColor:"#CCC"} : {}
            return(
            <div key={index} onClick={()=>{setProgressTab({...item, index})}} style={{display:"flex", justifyContent:"center", alignItems:"center", minHeight:"60px", height:"100%", ...activeBackground}}>
                <h5 style={{padding:"10px"}}>{`${index+1}.${item?.description}`}</h5>
             </div>
            )
        })}

    </div>
  )
} */

//=======================================================================================

/* export const StepByStepProgress = ({progressList}) => {

    const  [progressTab, setProgressTab] = useState(progressList[0])

    const activeIndex = progressList?.findIndex((x)=>x?.description == progressTab?.description)

    const nextStep = () => {
        //console.log("NEXT STEP")
        setProgressTab(progressList[activeIndex+1])
    }
    const previousStep = () => {
        //console.log("PREVIOUS STEP")
        setProgressTab(progressList[activeIndex-1])
    }
  return (
    <div>
        <ProgressHeader progressTab={progressTab} setProgressTab={setProgressTab} progressList={progressList}/>
        {progressList?.map?.((item, index)=>{
            return(
                <VisDiv key={index}  rules={[progressTab?.description == item?.description]}>
                    <h3>{item?.description}</h3>
                    {item?.component}
                </VisDiv>
            )
        })}
        <Divider/>
        <VisDiv style={{display:"flex", justifyContent:"space-around"}}>
            <VisDiv>
               {activeIndex>0 && <button className='pdf-button' onClick={previousStep}>PRECEDENTE</button>}
            </VisDiv>
            <VisDiv>
                {activeIndex < progressList?.length - 1 && <button className='pdf-button' onClick={nextStep}>SUCCESSIVO</button>}
            </VisDiv>
        </VisDiv>
      
    </div>
  )

} */

//=======================================================================================

/*************  ✨ Windsurf Command ⭐  *************/
/**
 * AddOrEditCustomerProduct is a component that allows the user to add or edit a customer product.
 * It uses the useStateContext to get the current customer and the updateDatabase function to update the database.
 * It also uses the useState hook to store the currently selected product and the product name.
 * The component renders a dropdown menu with the customer products, a button to create a new empty product, and a button to edit the currently selected product.
 * When the user selects a product, the component renders the product details and allows the user to edit them.
 * The component also renders a button to duplicate the currently selected product.
 * The component uses the VisDiv component to conditionally render the components based on the state of the component.
 * #offerManagement #labourProducts
 * @param {updateDatabase} function to update the database
 * @param {doc} the currently selected product
 * @param {setDoc} function to set the currently selected product
 * @param {data} an object with the customer products, suppliers, products, and price lists
 */
/*******  3375f353-197a-42dc-81cf-01d2d4cb8266  *******/
export const AddOrEditCustomerProduct = ({updateDatabase, doc, setDoc, data={}}) => { 
    const {customer} = useStateContext()
    const [productName, setProductName] = useState("")
    const [selectedProduct, setSelectedProduct] = useState("")
    const {customerProducts, supplyCustomerProducts, nonConformities, templateRegisters, presidioModules, deviceProperties, lists, dataModules, laws, products, suppliers, priceLists} = data 

    const [filterType, setFilterType] = useState({label:"ATTIVI", value: "ATTIVI"})
    const [viewEmpty, setEmpty] = useState(false)
    const [viewFilterFamily, setViewFilterFamily] = useState(false)
    const [templateRegister, setTemplateRegister] = useState()
    const filterTypes = [
            {label:"ATTIVI", value: "ATTIVI"},
            {label:"ARCHIVIATI", value: "ARCHIVIATI"},
        ]
    const filterByRegister = (item) => {
    if (templateRegister) return item?.registers?.some?.(y=>y?._ref == templateRegister?._id) 
    return item
    }
    const supplyCustomerProductsOptions = supplyCustomerProducts
        ?.filter(filterByRegister)
        ?.filter(x=>{
            if(filterType?.label == "ARCHIVIATI") return x?.status == "ARCHIVIATO"
            if(filterType?.label == "ATTIVI") return x?.status !== "ARCHIVIATO"
            return x
        })

    const duplicateDoc = () => ({
        ...selectedProduct, 
        label: productName, 
        _id: uuidv4(), 
        _key: keyId(),
    })

    const emptyDoc = () => ({
        _type: "customerProduct",
        _id: uuidv4(),
        _key: keyId(),
        label: "",
        customerProductCode:"",
        customer: referenceDoc(customer?._id),
        nonConformities: [],
        registers: [],
        devices: [],
        devicesExclude:false,
        deviceProperties: [],
        propertiesExclude: false,
        unit: 1,
        labourHours: 0.5,
        specialisedLabour: false,
        addFormulario: false,
        isSign: false,
        supply: true,
        substitution: false,
        maintenanceTask: false,
        allowZero: false,
        details: richEditorDoc(""),
        hideNonConformityDescription: false,
        supplyCustomerProducts: [],
        law: referenceDoc(""),
        supplierProducts: []

    })
    const labelValueDistance = 5
    const labourHours = selectedProduct?.labourHours ? selectedProduct?.labourHours : 0.5
    const defaultPriceList = !Array.isArray(priceLists) ? undefined : priceLists?.find?.((x)=>x?.default && x?.customer?._ref == customer?._id)
    const customerProductPriceLine = !Array.isArray(defaultPriceList?.products) ? undefined : defaultPriceList?.products?.find?.((x)=>x?.customerProduct?._ref == selectedProduct?._id)

    const selectedProductData = [
        {label: "NOME", value: selectedProduct?.label},
        {label: "REGISTRI", value: !Array.isArray(selectedProduct?.registers) ? [] : selectedProduct?.registers?.map?.((item)=> !Array.isArray(templateRegisters) ? undefined : templateRegisters?.find?.((x)=>x?._id == item?._ref)?.family)?.toString()},
        {label: "NON CONFORMITA'", value: !Array.isArray(selectedProduct?.nonConformities) ? [] : selectedProduct?.nonConformities?.map?.((item)=>!Array.isArray(nonConformities) ? undefined : nonConformities?.find?.((x)=>x?._id == item?._ref)?.label)?.toString()},
        {highlight: "green", value: selectedProduct?.devicesExclude && "ESCLUDE PRESIDI"},
        {label: "PRESIDI", value: !Array.isArray(selectedProduct?.devices) ? [] : selectedProduct?.devices?.map?.((item)=>!Array.isArray(presidioModules) ? undefined : presidioModules?.find?.((x)=>x?._id == item?._ref)?.label)?.toString()},
        {highlight: "green", value: selectedProduct?.propertiesExclude && "ESCLUDE PROPRIETA'"},
        {label: "PROPRIETA'", value: !Array.isArray(selectedProduct?.deviceProperties) ? [] : selectedProduct?.deviceProperties?.map?.((item)=>!Array.isArray(deviceProperties) ? undefined : deviceProperties?.find?.((x)=>x?._id == item?._ref)?.label)?.toString()},
        {label: "PRODOTTI FORNITURA ASSEGNATI", value: !Array.isArray(selectedProduct?.supplyCustomerProducts) ? [] : selectedProduct?.supplyCustomerProducts?.map?.((item)=>{
            const allCustomerProducts = [...customerProducts, ...supplyCustomerProducts]
            const findCustomerProduct = !Array.isArray(allCustomerProducts) ? undefined : allCustomerProducts?.find?.((x)=>x?._id == item?._ref)
            return (`${findCustomerProduct?.label}, ` )})
        }, 
        {label: "PRODOTTI SOSTITUZIONE ASSEGNATI", value: !Array.isArray(selectedProduct?.substitutionCustomerProducts) ? [] : selectedProduct?.substitutionCustomerProducts?.map?.((item)=>{
            const allCustomerProducts = [...customerProducts, ...supplyCustomerProducts]
            const findCustomerProduct = !Array.isArray(allCustomerProducts) ? undefined : allCustomerProducts?.find?.((x)=>x?._id == item?._ref)
            return (`${findCustomerProduct?.label}, ` )})
        },
        {label: "LEGGE", value: laws?.find?.((x)=> selectedProduct?.law?._ref == x?._id)?.label},
        {label: "DESCRIZIONE", value: selectedProduct?.details?.blocks?.map?.((x)=>x?.text)?.toString()},
        {label: "UNITA'", value: selectedProduct?.unit},
        {label: "ORE MANODOPERA", value: `${decimalToHoursConverter(labourHours)?.hours}:${decimalToHoursConverter(labourHours)?.minutes}`},
        {label: "PRODOTTI FORNITORE", value: !Array.isArray(selectedProduct?.supplierProducts) ? [] : selectedProduct?.supplierProducts?.map?.((item)=>{
            const findProduct = !Array.isArray(products) ? undefined : products?.find?.((x)=>x?._id == item?._ref)
            return (`${findProduct?.name}: € ${findProduct?.price}` )})
        }, 
        {label: "PREZZO LISTINO DEFAULT", value: `${customerProductPriceLine?.label}: € ${customerProductPriceLine?.price}`  }, 
        {highlight: "green", value: selectedProduct?.isSign && "CARTELLO"},
        {highlight: "green", value: selectedProduct?.supply && "FORNITURA"},
        {highlight: "green", value: selectedProduct?.hideNonConformityDescription && "DESCRIZIONE NON CONFORMITA' NASCOSTA"},
        {highlight: "green", value: selectedProduct?.specialisedLabour && "MANODOPERA SPECIALIZZATA"},
        {highlight: "amber", value: selectedProduct?.substitution && "SOSTITUZIONE"},
        {highlight: "amber", value: selectedProduct?.maintenanceTask && "MANUTENZIONE"},
        {highlight: "red", value: selectedProduct?.allowZero && "PERMETTI ZERO"},

    ]
    
 const createNewEmptyDoc = () => {
          const okFn = (name) => {
            const docToSave = emptyDoc()
              setDoc({...docToSave, label: name})
              updateDatabase({...docToSave, label: name})
              setProductName(name)
          }
          addNameSwal({docType:"PRODOTTO FORNITURA", okFn})
       
           
  }
    const duplicateExistingDoc = () => {
        const checks = () => {
            if(duplicateDoc()?.law?._id) return false
            if(!Array.isArray(duplicateDoc()?.supplierProducts)) return false
            if(duplicateDoc()?.supplierProducts?.some?.((x)=>x?._id)) return false
            return true
        }
        if(!checks()){
            errorAlert("Il prodotto non è stato duplicato, ricaricare e riprovare")
            return
        }
          const okFn = (name) => {
              const docToSave = duplicateDoc()
              setDoc({...docToSave, label: name})
              updateDatabase({...docToSave, label: name})
              setProductName(name)
              //console.log("skdaòsldkasòldk", {docToSave, selectedNonConformity, duplicateDoc: duplicateDoc(), name})
          }
          addNameSwal({docType:"PRODOTTO FORNITURA", okFn}) 
    }
    const editExistingDoc = () => {
        setDoc(selectedProduct)
    }

    return (
    <div>
        <div style={{marginBottom :"10px",display:"flex", cursor:"pointer", alignItems:"center"}} onClick={() => setViewFilterFamily(!viewFilterFamily)}>
            <h4>FILTRA PER FAMIGLIA:</h4>
            {viewFilterFamily ? <IoIosArrowDropupCircle size={25}/> : <IoIosArrowDropdownCircle size={25}/>}
        </div>
        <VisDiv rules={[viewFilterFamily]}>
                <SliderRegistriTemplates 
                    registerTemplateFilter={templateRegister} 
                    setRegisterTemplateFilter={setTemplateRegister} 
                    templates={!Array.isArray(templateRegisters) ? [] : templateRegisters?.filter?.((x)=>x?.customer?._ref == customer?._id)} 
                    //setLoading={setLoading}
                />
        </VisDiv>   
        <h3>SELEZIONA FILTRO:</h3>
        <FieldDropdown
            sorted={true}
            isSearchable="isSearchable"
            initialValue={filterType}
            placeHolder="Filtra Per Tipologia"
            options={filterTypes}
            onChange={(value) => {setFilterType(value)
        }}
        />
         <Divider />
        <FieldDropdown
            sorted={true}
            isSearchable="isSearchable"
            //initialValue={expandSupplier(supplierProduct?.supplier)}
            placeHolder={"SELEZIONA PRODOTTO FORNITURA ESISTENTE"}
            options={addValueForDropdown(supplyCustomerProductsOptions)}
            onChange={(value) => { 
                setSelectedProduct(value)
            }}
        />

        <div style={{display:"flex", justifyContent:"space-evenly"}}>
            <VisDiv rules={[]}>
                <button className="pdf-button" onClick={createNewEmptyDoc} >INSERISCI VUOTO</button>
            </VisDiv>
            <VisDiv rules={[selectedProduct]}> 
                <button className="pdf-button" onClick={editExistingDoc} >MODIFICA PRODOTTO ESISTENTE</button>
            </VisDiv>
            <VisDiv rules={[selectedProduct]}>
                <button className="pdf-button" onClick={duplicateExistingDoc} >DUPLICA PRODOTTO</button>
            </VisDiv>
        </div>
        <VisDiv rules={[selectedProduct]}>
            <Divider/>
            {!Array.isArray(selectedProductData) ? [] : selectedProductData?.map?.((item,index)=>{
                return(
                    <VisDiv key={index} rules={[item?.value]}>
                        <ViewLabelValueField 
                            label={item?.label} 
                            value={item?.value}
                            labelValueDistance={labelValueDistance}
                            highlight={item?.highlight}
                        />
                    </VisDiv>
                )
            })}

        </VisDiv>
    </div>
)}

//=======================================================================================

export const CustomerProductName = ({doc, setDoc, data}) => { 
    
    return (
    <div>
        <TextField 
            value={doc?.label} 
            onChange={(e) => setDoc({...doc, label: e.target.value})} 
            description={"Questo dato non sarà inserito nell'offerta, serve per trovare il prodotto"} 
            descriptionDivider={true}
        />
        <TextField 
            label={"CODICE PRODOTTO INTERNO"}
            value={doc?.customerProductCode} 
            onChange={(e) => setDoc({...doc, customerProductCode: e.target.value})} 
            description={"Deve esserediverso dal codice prodotto fornitore"} 
            descriptionDivider={false}
        />
    </div>
)}

export const AssignNonConformities = ({doc, setDoc, data}) => { 
    
    const {referenceData} = data
    return <ReferenceCheckList doc={doc} setDoc={setDoc} referenceData={referenceData}/>
}

//=======================================================================================

export const AssignRegisterTemplates = ({doc, setDoc, data}) => { 

    const {referenceData} = data
    return <ReferenceCheckList doc={doc} setDoc={setDoc} referenceData={referenceData}/>
    
}

//=======================================================================================

export const AssignAssets = ({doc, setDoc, data}) => { 
    
    const {referenceData} = data
    return (
    <div>
        <TrueFalseToggle 
            value={doc?.devicesExclude}
            onClick={()=>setDoc({...doc, devicesExclude: !doc?.devicesExclude})}
            label={"ESCLUDI PRESIDI"} 
            description={"Selezionare questa opzione se si vuole escludere i presidi selezionati invece di includerli. "}
        />
        <ReferenceCheckList doc={doc} setDoc={setDoc} referenceData={referenceData}/>
    </div>
    
)}

//=======================================================================================



export const AssignProperties = ({doc, setDoc, data}) => { 
    
    const {referenceData} = data
    return (
    <div>       
        <TrueFalseToggle 
            value={doc?.propertiesExclude}
            onClick={()=>setDoc({...doc, propertiesExclude: !doc?.propertiesExclude})}
            label={"ESCLUDI PROPRIETA'"} 
            description={"Selezionare questa opzione se si vuole escludere le proprietà selezionate invece di includerle. "}
        />
        <ReferenceCheckList doc={doc} setDoc={setDoc} referenceData={referenceData}/>
    </div>
    
)}

//=======================================================================================


export const LawAndDescription = ({doc={}, setDoc, data={}}) => {
    
    const {nonConformities, laws} = data
    const [viewAddLaw, setViewAddLaw] = useState(false)
    const [value, setValue] = useState(doc)
    const [law, setLaw] = useState(!Array.isArray(laws) ? undefined : laws?.find?.((x)=>doc?.law?._ref == x?._id))
    const queryClient = useQueryClient()

    const editorDocDescription = (data) => {
        //console.log("EDITOR DOC", data)
        const newValue = {...objectIsObject(value), details: {
            ...objectIsObject(data), 
            blocks: !Array.isArray(data?.blocks) ? [] : data?.blocks?.map?.((x)=>({...objectIsObject(x), _key: keyId()}))}}
        setValue(newValue)
        //setDoc(newValue)
        //setLaws([...filteredArray, newValue])
        

    }
    const saveDescription = () => {
       //const newValue = {...value, details: {...data, blocks: data?.blocks?.map?.((x)=>({...x, _key: keyId()}))}}
       //console.log("EDITOR BLUR", value)
       setDoc(value)
    } 
    
    const lawDoc = (lawId) => ({_ref: lawId, _key: keyId(), _type:"reference"})
    const editorDocLaw = (data) => {
        //console.log("EDITOR DOC", data)
        const newValue = {...value, law: {...data, blocks: data?.blocks?.map?.((x)=>({...x, _key: keyId()}))}}
        setValue(newValue)

    }
    const dataSchema = {
        schema: SchemaImport,
        documentName:"richTextLabelValue",
        richTextLabelValue: laws,
        //unique:[{name:"label", array: clients?.map?.(x=>x?.label)}],
        //required:["customer", "label"], 
        //suffix:[{name:"tenderDiscount", suffix:"%"}],
        autoFields:[{schema:"fieldType", value: "italy-law" }],
        hide:["fieldType", "value", "registerTemplates"], 
        //collection: laws
    }
    const {mutate: updateDocument} = useCreateReplace({
        onMutate: async (newDoc) => {

            await queryClient.cancelQueries({ queryKey: ['nonConformities'] })
            const previousData = queryClient.getQueryData(['nonConformities'])
       
            //const doc = newDoc?.doc
            
            queryClient.setQueryData(['nonConformities'], (old) =>{ 
                const doc = newDoc?.doc
                const oldData = old?.length > 0 ? old : []
                const newData = [...oldData?.filter?.(x=>x?._id!== doc._id), doc]          
                return newData
            })
            return {previousData }
        },

        onError: (err, newDoc, context) => {
            console.error('Oh no, the update failed: ', err?.message)
            errorAlert("ERRORE: Il documento non è stato modificato, riprovare")
        }

        })

    const saveNewLaw = (data) => {
        //console?.log("DOC TO SAVE", data)
        const queryDoc = {
            doc: data,
        }
        console.log("SAVE DOC", queryDoc)
        updateDocument(queryDoc,{
            onSuccess:()=>{
                console.log("Document Updated Successfully", data);
                setLaw(data)
                const newValue = {
                    ...doc, 
                    law: lawDoc(data?._id), 
                }
                setValue(newValue)
                setDoc(newValue)
                setViewAddLaw(false);
            }
        })
      
    }
    return (    
    <div>

        <VisDiv style={{display:"flex"}}>
            <VisDiv rules={[true]} style={{flex:1.5, padding: "10px"}}> 
                <h4>DESCRIZIONE</h4>
                <RichTextEditor onBlur={saveDescription} noFocus={true} existingDoc={doc?.details} readOnly={false} editorDoc={editorDocDescription}/>
            </VisDiv>

            <VisDiv rules={[true]} style={{flex:1, padding: "10px"}}>
                <h4>LEGGE</h4>
                <VisDiv style={{display:"flex", alignItems:"center"}}>
                    <div style={{minWidth:"90%"}}>
                        <FieldDropdown
                            isSearchable="isSearchable"
                            initialValue={{...law, value: law?.label}}
                            placeHolder={"LEGGE"}
                            options={addValueForDropdown(laws)?.sort(sortByLabel)}
                            onChange={(value) => {
                                setLaw(value)
                                const newValue = {
                                    ...doc, 
                                    law: lawDoc(value?._id), 
                                }
                                setValue(newValue)
                                setDoc(newValue)
                            }
                            }
                        />
                    </div>
                    <VisDiv className='round-back-button' style={{backgroundColor:"white", marginLeft:"10px"}} onClick={()=>setViewAddLaw(!viewAddLaw)}> 
                        <IoIosAddCircleOutline fontSize={30} />
                    </VisDiv>
                </VisDiv>
                <VisDiv rules={[viewAddLaw]} style={{marginBottom:"10px"}}>
                <div className="titleCloseBtn">
                    <button
                    onClick={() => {
                        setViewAddLaw(false);
                    }}
                    >
                    X
                    </button>
                </div>
            <ManageSchema
                data = {dataSchema}
                saveFn={saveNewLaw}
                //selectedDoc={selectedDocFn}
                //archiveFn={archive}
            />             
        </VisDiv>
            <RichTextEditor noFocus={true} existingDoc={law?.richText} readOnly={true} editorDoc={editorDocLaw} updateInitialData={true}/> 
        </VisDiv>

        </VisDiv>
        <TrueFalseToggle 
            value={doc?.hideNonConformityDescription}
            onClick={()=>setDoc({...doc, hideNonConformityDescription: !doc?.hideNonConformityDescription})}
            label={"NASCONDI DESCRIZIONE NON CONFORMITA"} 
            description={"Selezionare questa opzione se si vuole nascondere la descrizione della non conformità da questo prodotto. "}
        />
        <VisDiv rules={[true]}>
                <h3>NON CONFORMITA' ASSEGNATE AL PRODOTTO</h3>
                {doc?.nonConformities?.map?.((nc)=>{
                    const nonConformity = !Array.isArray(nonConformities) ? undefined : nonConformities?.find?.((x)=>x?._id == nc?._ref)
                    return (
                        <div key={nonConformity?._id}>
                            <VisDiv rules={[false]}>
                                <p onClick={(()=>console.log(nonConformity, nonConformities))}>test</p>
                            </VisDiv>
                            <div>
                                <p>{nonConformity?.label}</p>
                            </div>
                        </div>
                    )
                })}
        </VisDiv>
    </div>
)}

//=======================================================================================

export const AssignSupplierProduct = ({doc, setDoc, data}) => { 
    
    const {referenceData} = data
    const [documentToEdit, setDocumentToEdit] = useState(null)
    const [viewAddProduct, setViewAddProduct] = useState(false)
    const assign = (data) => {
        const newDoc = {
            ...doc,
            supplierProducts:[...doc?.supplierProducts?.filter((x=>x?._ref !== data?._id)), referenceDoc(data?._id)]
        }
        setDoc(newDoc)
        
    }

    const editItem = (data) => {
       
        const findFullProduct = referenceData?.data?.find((x) => x?._id == data?._id)
        if(!findFullProduct){
            console.error("PRODOTTO NON TROVATO", data)
            return
        }
        console.log("msalksamlxkamsklx in InsertCustomerProduct", {data, referenceData, findFullProduct})
        setDocumentToEdit(findFullProduct)
    }

    return( 
    <div>
    <AddSupplierProduct viewAddProduct={viewAddProduct} setViewAddProduct={setViewAddProduct} documentToEdit={documentToEdit} suppliers={referenceData?.suppliers} setNewDocument={assign}/>
    <ReferenceCheckList editItem={editItem} showEditButton={true}  doc={doc} setDoc={setDoc} referenceData={referenceData}/>
    </div>
    )
}
//=======================================================================================
export const AssignSubstitutionProduct = ({doc, setDoc, data}) => { 
    
    const {referenceData} = data
    return (
    <div>
        <ReferenceCheckList doc={doc} setDoc={setDoc} referenceData={referenceData}/>
    </div>
    )
}
//=======================================================================================

export const CustomerProductSettings = ({doc, setDoc, data}) => { 

    
    const hourDoc = (data) => {
        //console.log("DECIMAL MINUTES", data)
        setDoc({...doc, labourHours: data?.decimal})
    }
    const [unitDoc, setUnitDoc] = useState(doc)
 
    return (
    <div style={{marginTop:"10px"}}>
        <TextField 
            onBlur={()=> setDoc({...unitDoc, unit: Number(unitDoc?.unit)})}
            value={unitDoc?.unit} 
            onChange={(e) => setUnitDoc({...unitDoc, unit: e.target.value})} 
            label={"UNITA'"}
            type={"number"}
            description={"Inserire il numero di unità. Per esempio se deve uscire più di una volta, come nel caso dei cartelli nelle porte/uscite a doppia anta o nel numero dei Kg per lo smaltimento degli estintori"} 
        />
        <DecimalHours 
            initialDecimalValue={doc?.labourHours} 
            docFn={hourDoc} 
            //defaultMinutes={30}
            description={"Inserire il numero di ore di manodopera. il default è di mezz'ora se lasciato vuoto"} 
            label={"ORE MANODOPERA (DECIMALE)"}
            descriptionDivider={true}
        />
        <TrueFalseToggle 
            value={doc?.specialisedLabour}
            onClick={()=>setDoc({...doc, specialisedLabour: !doc?.specialisedLabour})}
            label={"MANODOPERA"} 
            description={"Questo prodotto deve essere nella sezione manodopera"}
        />    
        <TrueFalseToggle 
            value={doc?.addFormulario}
            onClick={()=>setDoc({...doc, addFormulario: !doc?.addFormulario})}
            label={"AGGIUNGI FORMULARIO ESTINTORI"} 
            description={"Questo prodotto se presenta genera il formulario estintori"}
        />
        <TrueFalseToggle 
            value={doc?.isSign}
            onClick={()=>setDoc({...doc, isSign: !doc?.isSign})}
            label={"CARTELLO"} 
            description={"Selezionare questa opzione se questo prodotto è un cartello"}
        />
        <TrueFalseToggle 
            value={doc?.substitution}
            onClick={()=>setDoc({...doc, substitution: !doc?.substitution})}
            label={"SOSTITUZIONE"} 
            description={"Selezionare questa opzione solo se questo prodotto è in sostituzione ad un'altro presidio"}
        />
        <TrueFalseToggle 
            value={doc?.supply}
            onClick={()=>setDoc({...doc, supply: !doc?.supply})}
            label={"FORNITURA"} 
            description={"Selezionando questa opzione porta o leva questo prodotto dalla sezione forniture"}
        />
        <TrueFalseToggle 
            value={doc?.maintenanceTask}
            onClick={()=>setDoc({...doc, maintenanceTask: !doc?.maintenanceTask})}
            label={"MANUTENZIONE"} 
            description={"Selezionare questa opzione solo se questo prodotto descrive una manutenzione da registro, come una revisione, collaudo o tagliando"}
        />
        <TrueFalseToggle 
            value={doc?.allowZero}
            onClick={()=>setDoc({...doc, allowZero: !doc?.allowZero})}
            label={"PERMETTI ZERO"} 
            description={"Selezionare questa opzione se si vuole che il prezzo di questo prodotto possa essere 0. Se selezionata, la riga dell'offerta non sarà sottolineata in rosso"}
        />
        <TrueFalseToggle 
            value={doc?.descriptionNotUnique}
            onClick={()=>setDoc({...doc, descriptionNotUnique: !doc?.descriptionNotUnique})}
            label={"DESCRIZIONE NON UNIVOCA"} 
            description={"Selezionare questa opzione se si vuole che questa descrizione possa non essere univoca. Selezionare solo se il prodotto fornitore è lo stesso e si vuole che prodotti diversi si sommino (es: GESTIONE RIFIUTI ESTINTORI)"}
        />
        <TrueFalseToggle 
            value={doc?.productNotUnique}
            onClick={()=>setDoc({...doc, productNotUnique: !doc?.productNotUnique})}
            label={"PRODOTTO NON UNIVOCO"} 
            description={"Selezionare questa opzione se si vuole che questo prodotto possa uscire più volte nell'offerta es. se esce da diverse non conformità"}
        />

    </div>
)}

//=======================================================================================

export const AssignPriceList = ({doc, setDoc, data}) => { 
    const {customer, priceLists, hideSearch} = data
    const filterByProduct = (x) => {
        return x?.customerProduct?._ref == doc?._id
    }
    return (
    <div>
      <PriceLists data={{...data, defaultCustomerProduct: doc}} filterByProduct={filterByProduct}/>
    </div>
)}

//=======================================================================================

export const AssignSupplyCustomerProducts = ({doc, setDoc, data}) => { 
    
    const {referenceData} = data
    return (
    <div>
        <ReferenceCheckList doc={doc} setDoc={setDoc} referenceData={referenceData}/>
    </div>
    
)}

//=======================================================================================

